import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { useState } from "react";
import { TablePagination } from "../ui/data-table/TablePagination";
import { useTransactions } from "./hooks/useTransactions";
import { TransactionGroup } from "./TransactionGroup";

interface TransactionTableProps {
  transactionType?: string;
  period?: string;
}

export const TransactionTable = ({ transactionType, period = "all" }: TransactionTableProps) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const { data: transactions, isLoading } = useTransactions(transactionType, period);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center p-4 md:p-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  if (!transactions || transactions.length === 0) {
    return (
      <div className="text-center p-4 md:p-8 text-gray-500">
        Aucune transaction trouvée
      </div>
    );
  }

  // Group transactions by date
  const groupedTransactions = transactions.reduce((groups: any, transaction) => {
    const date = format(new Date(transaction.created_at), 'PP', { locale: fr });
    if (!groups[date]) {
      groups[date] = [];
    }
    groups[date].push(transaction);
    return groups;
  }, {});

  const dates = Object.keys(groupedTransactions);
  const totalPages = Math.ceil(dates.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentDates = dates.slice(startIndex, endIndex);

  return (
    <div className="space-y-4 md:space-y-8 w-full overflow-hidden">
      <div className="overflow-x-auto">
        {currentDates.map((date) => (
          <TransactionGroup
            key={date}
            date={date}
            transactions={groupedTransactions[date]}
            transactionType={transactionType}
          />
        ))}
      </div>
      {totalPages > 1 && (
        <div className="mt-4">
          <TablePagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        </div>
      )}
    </div>
  );
};